"use client";

// admin-ui-rework, Этап 1: кнопка-иконка. Видимый текст отсутствует → aria-label
// обязателен (QA-SHARED-6). Цвета — семантические tailwind-токены
// (text-secondary/surface), см. README «Tailwind-контракт».
// forwardRef обязателен: компонент используется как триггер Radix (asChild) —
// без ref библиотека не может измерить якорь и позиционирует меню мимо экрана.
import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";

/** sm — плотные списки/панели; md — дефолт хрома приложения. */
export const ICON_BUTTON_SIZE = { sm: "sm", md: "md" } as const;
export type IconButtonSize = (typeof ICON_BUTTON_SIZE)[keyof typeof ICON_BUTTON_SIZE];

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** aria-label — обязателен, видимого текста у кнопки нет. */
  label: string;
  size?: IconButtonSize;
  children: ReactNode;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, size = ICON_BUTTON_SIZE.md, className, children, style, ...rest },
  ref,
) {
  const box = size === ICON_BUTTON_SIZE.sm ? "--ui-icon-button-sm-size" : "--ui-icon-button-md-size";
  return (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      className={`flex shrink-0 items-center justify-center text-text-secondary transition-colors hover:bg-surface hover:text-text-primary ${className ?? ""}`}
      style={{
        ...style,
        width: `var(${box})`,
        height: `var(${box})`,
        borderRadius: "var(--ui-icon-button-radius)",
      }}
      {...rest}
    >
      {children}
    </button>
  );
});
